import getSingle from "./get-single.js";
import updateSingle from "./update-single.js";
import deleteSingle from "./delete-single.js";
import getMultiple from "./get-multiple.js";
import clearSingleProcessed from "./clear-single-processed.js";
import clearAllProcessed from "./clear-all-processed.js";
import getPresignedUrl from "./get-presigned-url.js";
import createSingle from "./create-single.js";

export default {
	updateSingle,
	getSingle,
	deleteSingle,
	getMultiple,
	clearSingleProcessed,
	clearAllProcessed,
	getPresignedUrl,
	createSingle,
};
